import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefreshIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 16.5 15.9",
	style: { enableBackground: "new 0 0 16.5 15.9" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.refresh-icon-st0{fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "refresh-icon-st0",
		d: "M11.7,5.8h3.8V2"
	}), /* @__PURE__ */ _jsx("path", {
		className: "refresh-icon-st0",
		d: "M12.8,12.9c-1,1-2.2,1.6-3.5,1.9s-2.7,0.1-4-0.4C4,13.8,2.9,13,2.2,11.8C1.4,10.7,1,9.3,1,8 c0-1.4,0.4-2.7,1.2-3.8C2.9,3,4,2.2,5.3,1.6s2.6-0.7,4-0.4c1.3,0.3,2.6,0.9,3.5,1.9l2.7,2.7"
	})] }) }) })]
});
export default SvgRefreshIcon;
